import React from 'react';
import { Text as ChakraTextBase } from '@chakra-ui/react';

/**
 * Chakra UI版のTextコンポーネント
 * 既存のTailwind版と並行して使用可能
 */
const ChakraText = ({
  children,
  fontSize = 'md',
  color = 'gray.700',
  fontWeight = 'normal',
  lineHeight = 'relaxed',
  textAlign,
  mb,
  ...props
}) => {
  return (
    <ChakraTextBase
      fontSize={fontSize}
      color={color}
      fontWeight={fontWeight}
      lineHeight={lineHeight}
      textAlign={textAlign}
      mb={mb}
      {...props}
    >
      {children}
    </ChakraTextBase>
  );
};

export default ChakraText;